import { render, staticRenderFns } from "./ReductionTargets.vue?vue&type=template&id=126c3112"
import script from "./ReductionTargets.vue?vue&type=script&lang=js"
export * from "./ReductionTargets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports